<template>
  <!-- 项目主题 -->
  <div class="id_1">

    <div class="title bold" v-html="data.title"></div>

  </div>
</template>

<script>

export default {
  props: {
    data: Object
  },
  name: 'id_1',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.id_1{
  padding-top: 40px;
  background-color: #fff;
  word-wrap:break-word;
  .title{
    font-size: 18px;
    line-height: 25px;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/course/public/id_1.vue